<template>
  <sticky-header-layout>
    <template #header>
      <div 
        class="action-container"
      >
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >{{ $t('button.create') }}</el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
    >
      <el-table-column
        label="Type"
        prop="type"
        min-width="80"
      />

      <el-table-column
        label="Status"
        prop="status"
        min-width="80"
      />

      <el-table-column
        label="Remarks"
        prop="remarks"
        min-width="120"
      />

      <el-table-column
        label="Brand"
        prop="brand"
        min-width="120"
      />

      <el-table-column
        label="Marketing U1"
        prop="marketing_u1"
        min-width="120"
      />

      <el-table-column
        label="Target"
        prop="target"
        min-width="100"
      />
      
      <el-table-column
        label="Start Date"
        prop="start_date"
        min-width="100"
      />

      <el-table-column
        label="End Date"
        prop="end_date"
        min-width="100"
      />
    </el-table>
  </sticky-header-layout>
</template>

<script>
import CPCCampaignService from '../../api/cpc-campaign'

export default {
  name: 'CPCCampaignList',
  data() {
    return {
      isLoading: false,
      list: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleCreate() {
      this.$router.push({ path: '/cpc-campaign/create' })
    },
    async getList() {
      this.isLoading = true
      try {
        const response = await CPCCampaignService.list()
        this.list = response.data
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
